import { render, staticRenderFns } from "./TianjiaHuowuThree.vue?vue&type=template&id=896e4166&"
import script from "./TianjiaHuowuThree.vue?vue&type=script&lang=js&"
export * from "./TianjiaHuowuThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports